export default __webpack_public_path__ + "static/wemoney-lender-2022-08232d7201e1281df556e39998e44f5a.svg";